'use client';

import { jsx, jsxs } from "react/jsx-runtime";
import { LoadingSpinner } from "../../atoms/LoadingSpinner/LoadingSpinner.js";
import { Text } from "../../atoms/Text/Text.js";
import { classNames } from "../../utils/styles/classNames.js";
import { loadingStartMsg } from "./Select.data.js";
import { FakeOption } from "./Select.FakeOption.js";
import { loading } from "./Select.css.js";
function Loading({ isLoading }) {
  return isLoading && /* @__PURE__ */ jsx(FakeOption, { children: /* @__PURE__ */ jsxs("div", { className: classNames(loading), children: [
    /* @__PURE__ */ jsx(LoadingSpinner, { size: "sm" }),
    /* @__PURE__ */ jsx(Text, { color: "onLight.text.tertiary", children: loadingStartMsg })
  ] }) });
}
export {
  Loading
};
